import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import PaymentOptionFormCod from './PaymentOptionFormCod.vue';
import PaymentOptionFormBank from './PaymentOptionFormBank.vue';
import PaymentOptionFormCreditCard from './PaymentOptionFormCreditCard.vue';
import PaymentShippingRequiredDialog from './PaymentShippingRequiredDialog.vue';
import PaymentOptionFormXendit from './PaymentOptionFormXendit.vue';
let PaymentOptionForm = class PaymentOptionForm extends Vue {
    get paymentOptionForm() {
        if (this.paymentGateway.title === 'COD by Ninja Van') {
            return PaymentShippingRequiredDialog;
        }
        if (this.paymentGateway.title === 'Xendit Online Payment Gateway') {
            return PaymentOptionFormXendit;
        }
        if (this.paymentGateway.cod ||
            this.paymentGateway.thirdPartyOnlineOption ||
            this.paymentGateway.creditCard) {
            return PaymentOptionFormCod;
        }
        if (this.paymentGateway.bank) {
            return PaymentOptionFormBank;
        }
        if (this.paymentGateway.thirdPartyProvider) {
            return PaymentOptionFormCreditCard;
        }
        return null;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], PaymentOptionForm.prototype, "toggle", void 0);
__decorate([
    Prop({ type: Object, default: () => ({}) })
], PaymentOptionForm.prototype, "paymentGateway", void 0);
PaymentOptionForm = __decorate([
    Component({
        components: {
            PaymentOptionFormCod,
            PaymentOptionFormXendit,
        },
    })
], PaymentOptionForm);
export default PaymentOptionForm;
